// College Board Skills Insight performance score bands: the one scale for
// "what SAT section score does Level N mean" across the app (Sandy 2026-10-06,
// from College Board's own table). Printed as the real scores inside each band:
// section scores come in tens, so these edges are exact and disjoint (band 1 is
// "below 370"). Math and Reading & Writing differ only at Levels 3 and 4.
// Not a placement rule: claude-student-api places from the diagnostic separately.
export const SAT_SCORE_BANDS = {
  reading: { 1: [200, 360], 2: [370, 410], 3: [420, 480], 4: [490, 540], 5: [550, 600], 6: [610, 670], 7: [680, 800] },
  math: { 1: [200, 360], 2: [370, 410], 3: [420, 460], 4: [470, 540], 5: [550, 600], 6: [610, 670], 7: [680, 800] },
};

// [lo, hi] section score for a subject ('reading' | 'math') at a level, clamped to 1-7.
export function bandRange(subject, band) {
  const table = SAT_SCORE_BANDS[subject === 'math' ? 'math' : 'reading'];
  return table[Math.max(1, Math.min(7, Math.round(Number(band) || 1)))];
}
